/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderImgVo
 */
export interface OrderImgVo {
    /**
     * 快递图片
     * @type {string}
     * @memberof OrderImgVo
     */
    fileUrl?: string;
    /**
     * 快递图片id
     * @type {number}
     * @memberof OrderImgVo
     */
    id?: number;
}

/**
 * Check if a given object implements the OrderImgVo interface.
 */
export function instanceOfOrderImgVo(value: object): value is OrderImgVo {
    return true;
}

export function OrderImgVoFromJSON(json: any): OrderImgVo {
    return OrderImgVoFromJSONTyped(json, false);
}

export function OrderImgVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderImgVo {
    if (json == null) {
        return json;
    }
    return {
        
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function OrderImgVoToJSON(json: any): OrderImgVo {
    return OrderImgVoToJSONTyped(json, false);
}

export function OrderImgVoToJSONTyped(value?: OrderImgVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileUrl': value['fileUrl'],
        'id': value['id'],
    };
}

